export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-primary-500 to-primary-700 rounded-2xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="flex-1 p-8 md:p-12 lg:p-14 text-background-50">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-background-50/20 text-sm font-medium mb-4 whitespace-nowrap">
                <i className="ri-download-cloud-2-line"></i>
                移动端与APP
              </div>
              <h2 className="text-2xl md:text-3xl font-heading font-bold mb-3">
                51吃瓜APP下载
              </h2>
              <p className="text-background-50/85 text-sm leading-relaxed mb-6 max-w-[480px]">
                支持安卓与iOS双平台，享受更流畅的浏览体验、实时推送通知和离线缓存功能。
                手机版网页同样支持一键直达，永久域名稳定访问。
              </p>
              <div className="flex flex-col sm:flex-row gap-3">
                <a
                  href="#"
                  className="whitespace-nowrap inline-flex items-center justify-center gap-2 px-6 py-3 bg-background-50 text-primary-700 font-medium rounded-full hover:bg-background-100 transition-colors cursor-pointer text-sm"
                >
                  <i className="ri-android-line text-lg"></i>
                  安卓版下载
                </a>
                <a
                  href="#"
                  className="whitespace-nowrap inline-flex items-center justify-center gap-2 px-6 py-3 bg-background-50/15 text-background-50 font-medium rounded-full border border-background-50/30 hover:bg-background-50/25 transition-colors cursor-pointer text-sm"
                >
                  <i className="ri-apple-line text-lg"></i>
                  iOS版下载
                </a>
                <a
                  href="#"
                  className="whitespace-nowrap inline-flex items-center justify-center gap-2 px-6 py-3 bg-background-50/15 text-background-50 font-medium rounded-full border border-background-50/30 hover:bg-background-50/25 transition-colors cursor-pointer text-sm"
                >
                  <i className="ri-global-line text-lg"></i>
                  网页版入口
                </a>
              </div>
            </div>
            <div className="flex-1 w-full lg:w-auto p-6 md:p-8 flex justify-center">
              <div className="relative w-[220px] h-[440px] md:w-[260px] md:h-[500px]">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20mockup%20displaying%20entertainment%20news%20app%20interface%20with%20warm%20red%20and%20white%20color%20scheme%2C%20clean%20UI%20design%20with%20trending%20topics%20list%2C%20floating%20phone%20on%20dark%20gradient%20background%2C%20professional%20product%20photography%2C%20sleek%20and%20modern%20aesthetic&width=520&height=1000&seq=app-mockup-2026&orientation=portrait"
                  alt="51吃瓜APP手机版界面展示"
                  className="w-full h-full object-contain"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}